import styled from 'styled-components';
import themeColors from '../assets/styles/themeColors';
import { variables } from '../assets/styles/variables';

export const Heading = styled.h2`
  font-weight: ${(props) => props.fontWeight || 600};
  font-size: ${variables.typography.h.subtitle.fontSize};
  line-height: ${variables.typography.h.subtitle.lineHeight};
  color: ${({ color }) => color || themeColors.colorTextSecondary};
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : '10px')};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : '0')};
  text-align: ${(props) => (props.textAlign ? `${props.textAlign}` : 'left')};
`;

export const HeadingSubtitle = styled.h2`
  font-weight: 600;
  font-size: ${variables.typography.h.subtitle.fontSize};
  line-height: ${variables.typography.h.subtitle.lineHeight};
  color: ${({ color }) => color || themeColors.colorTextLight};
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : '10px')};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : '0')};
`;

export const HeadingParagraph = styled.h3`
  font-weight: ${({ isNormal }) => (isNormal ? 500 : 600)};
  font-size: ${variables.typography.h.paragraph.fontSize};
  line-height: ${variables.typography.h.paragraph.lineHeight};
  color: ${themeColors.colorTextSecondary};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : '0')};
`;
